import React, {ReactNode} from 'react';
import styles from './FogContainer.module.css'
import clsx from "clsx";

export enum EnumFog {
    light = 'light',
    middle = 'middle',
    strong = 'strong',
    veryStrong = 'veryStrong'
}

interface IProps {
    children: ReactNode,
    fogPower?: EnumFog
}

const FogContainer = ({children, fogPower}: IProps) => {
    return (
        <div className={clsx(
            styles.fogContainer,
            !fogPower && styles.fogMiddle,
            fogPower === EnumFog.light && styles.fogLight,
            fogPower === EnumFog.middle && styles.fogMiddle,
            fogPower === EnumFog.strong && styles.fogStrong,
            fogPower === EnumFog.veryStrong && styles.fogVeryStrong,
        )}>
            {children}
        </div>
    );
};

export default FogContainer;